import {
    PrescriptionFormControllerApi,
    UpdatePrescriptionStatusStatusEnum,
} from "../../../../services";
import {
    getConfigObject,
    getXtenantId,
    useMutationWithLoading,
} from "../../../../utils/utils";

interface Params {
  prescriptionFormId: string;
  status: UpdatePrescriptionStatusStatusEnum;
  reason?: string;
  pharmacyResponse?: string;
}

/**
 * @author Rajkumar Rathod
 */
export const usePrescriptionStatusChange = () =>
  useMutationWithLoading(async (params: Params) =>
    new PrescriptionFormControllerApi(
      getConfigObject()
    ).updatePrescriptionStatus(
      params?.prescriptionFormId,
      params?.status,
      params?.reason,
      params?.pharmacyResponse,
      getXtenantId()
    )
  );
